import { Box, Grid, makeStyles } from "@material-ui/core"
import NCText from "../../shared/NCText"
import { useParams } from "react-router-dom"
import { useState, useEffect } from "react"
import NotificationAlert from "../../components/notification/NotificationAlert"
import TopNavBar from "../../components/TopNavBar"
import { useTranslation } from "react-i18next"
import API from "../../libs/api"
import { API_PATH } from "../../libs/config"
import NCLoader from "../../shared/NCLoader"

const useStyles = makeStyles(() => ({
  section: {
    border: "1px solid #D1D5DB",
    borderRadius: 8,
    overflow: "hidden",
    marginBottom: 16,
  },
  sectionHeader: {
    backgroundColor: "#F9FAFB",
    padding: "12px 16px",
    borderBottom: "1px solid #D1D5DB",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 16px",
    borderBottom: "1px solid #F3F4F6",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  label: {
    color: "#6B7280",
    fontSize: 14,
  },
  value: {
    fontWeight: 500,
    fontSize: 14,
  },
  passengerRow: {
    padding: "8px 16px",
    borderBottom: "1px solid #F3F4F6",
    "&:last-child": {
      borderBottom: "none",
    },
  },
}))

const STATUS_DISPLAY = {
  9: "Cancelled by Driver",
  10: "Cancelled by Client",
  11: "Expired",
  12: "No Driver Found",
  13: "Rejected by Driver",
  15: "Cancelled via Portal",
}

const CANCELLED_BY_ROLE = {
  9: "Driver",
  10: "Client/Guardian",
  11: "System",
  12: "System",
  13: "Driver",
  15: "Dispatcher",
}

const CancelledRidesDetail = () => {
  const cls = useStyles()
  const { t } = useTranslation()
  const { id } = useParams()
  const [trip, setTrip] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    API.get(`${API_PATH.TRIPS}${id}/`)
      .then(res => setTrip(res.data?.data || res.data))
      .catch(() => setTrip(null))
      .finally(() => setLoading(false))
  }, [id])

  if (loading) return <NCLoader open />
  if (!trip) return <NCText>{t("Trip not found")}</NCText>

  const statusCode = trip.status
  const statusLabel = STATUS_DISPLAY[statusCode] || `Status ${statusCode}`
  const cancelledBy = trip.cancelled_by_name || CANCELLED_BY_ROLE[statusCode] || t("Unknown")

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box mb={2}>
          <Grid container justifyContent="space-between">
            <Grid item xs={12} sm={6} md={4}>
              <NCText variant={"h4"}>{t("Cancelled Ride Details")}</NCText>
            </Grid>
            <Grid item>
              <NotificationAlert />
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Box>
          <TopNavBar lastLabel={`Trip #${id}`} />
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box className={cls.section}>
          <Box className={cls.sectionHeader}>
            <NCText style={{ fontWeight: 600, fontSize: 16 }}>{t("Ride Information")}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Trip ID")}</NCText>
            <NCText className={cls.value}>#{trip.id}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Client")}</NCText>
            <NCText className={cls.value}>{trip.client?.name || trip.name || "-"}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Driver")}</NCText>
            <NCText className={cls.value}>{trip.driver?.name || "-"}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Aid Monitor")}</NCText>
            <NCText className={cls.value}>{trip.aid_monitor?.name || "-"}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Pickup Time")}</NCText>
            <NCText className={cls.value}>{trip.pickup_time ? new Date(trip.pickup_time).toLocaleString() : "-"}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Status")}</NCText>
            <NCText className={cls.value} style={{ color: "#E22134" }}>{statusLabel}</NCText>
          </Box>
        </Box>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box className={cls.section} style={{ marginLeft: 16 }}>
          <Box className={cls.sectionHeader}>
            <NCText style={{ fontWeight: 600, fontSize: 16 }}>{t("Cancellation Details")}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Cancelled By")}</NCText>
            <NCText className={cls.value} style={{ color: "#E22134" }}>{cancelledBy}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Reason")}</NCText>
            <NCText className={cls.value}>{trip.cancel_reason || trip.no_show_hold_reason || "-"}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Pickup Address")}</NCText>
            <NCText className={cls.value}>{trip.pickup_address?.address || "-"}</NCText>
          </Box>
          <Box className={cls.row}>
            <NCText className={cls.label}>{t("Drop-off Address")}</NCText>
            <NCText className={cls.value}>{trip.drop_off_address?.address || "-"}</NCText>
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}

export default CancelledRidesDetail
